<template>
	<a :href="`/article/${article.id}`">
	<div class="card">
		<RatioImage 
			ratio="2:1" 
			:src="imgProxy(article.thumbnail, rs='fill:400:200:1')"
			:tip="article.title"
			class="card-img-top"
		/>
		
	  	<div class="card-body">
	    	<h5 class="card-title text-truncate-3">{{ article.title }}</h5>
	    	<p class="card-text text-truncate">{{ article.summary }}</p>
	    	<p class="card-text text-right"><small class="text-muted">{{ dateFormat(article.created_at, format) }}</small></p>
	  	</div>
	</div>
	</a>
</template>

<script setup>
import { computed } from 'vue'
import { dateFormat, imgProxy } from "../../utils"
import RatioImage from '../RatioImage.vue'

const props = defineProps({
  article: Object,
})

const format = "YYYY/MM/DD"

</script>